var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zu-tips-wrap",style:(_vm.newStyle)},[(_vm.showIcon)?_c('i',{class:[_vm.icon, 'zu-tips-icon']}):_vm._e(),_c('span',{staticClass:"zu-tips-text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }